import { gql } from "@apollo/client";

const GET_NOVEDADES_VISITA = gql`
query novedadVisitas($idVisita: Int!) {
    novedadVisitas(idVisita: $idVisita) {
        idNovedad
        descripcion
        idVisita
        idUsuarioAlta
        fechaAlta
        nombre
        apellido
        matriculas
    }
}`;

export default GET_NOVEDADES_VISITA;

export const adaptNovedadesVisita = (data) => {
    if (!data || !Array.isArray(data)) return [];
    return data.map(item => ({
        idNovedad: item.idNovedad,
        descripcion: item.descripcion,
        idVisita: item.idVisita,
        idUsuarioAlta: item.idUsuarioAlta,
        fechaAlta: item.fechaAlta,
        usuario: {
            nombre: item.nombre || '',
            apellido: item.apellido || ''
        },
        matricula: item.matriculas
    }));
};
